module.exports = __webpack_public_path__ + "static/media/080-recycle bin.6cf4a7fe.svg";